export default "__VITE_ASSET__DJfpIwD2__"